'use client';

import { FeatureViewed } from '@cc-shopping/platform-analytics/FeatureViewed';
import { usePageAction } from '@cc-shopping/platform-analytics/hooks/usePageAction';
import { palette } from '@cc-shopping/ui/theme';
import { Button } from '@mui/material';
import { CARD_FINDER_OPEN_ACTION } from 'src/features/navigation/Entrypoint/constants';
import { getEntryPointUrl } from 'src/features/navigation/Entrypoint/utils';

const ENTITY_SECTION = 'ru_cardfinder_entry';

export function CardfinderEntrypointBlueVariantCta() {
  const firePageAction = usePageAction({
    ...CARD_FINDER_OPEN_ACTION,
    actionSection: ENTITY_SECTION,
  });

  return (
    <FeatureViewed
      entityName="cc_recommend_flow"
      entitySection={ENTITY_SECTION}
      impressionPosition={0}
    >
      <Button
        href={getEntryPointUrl()}
        onClick={() => firePageAction()}
        variant="contained"
        fullWidth
        sx={{
          bgcolor: palette.secondary.main,
          color: palette.common.white,
          borderRadius: 1,
          py: 1.5,
          px: 4,
          letterSpacing: '0.05em',
          lineHeight: 1.5,
          boxShadow: 'none',
          '&:hover': {
            bgcolor: palette.blues.dark,
            boxShadow: 'none',
          },
        }}
      >
        Try our free quiz
      </Button>
    </FeatureViewed>
  );
}
